import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { APP_3D_API_URL, isManagerOrAdmin, USER_TYPE_ADMIN, USER_TYPE_MANAGER } from "../../utils/constants";
import {
  getRecentProjects, processProject, updateRotation
} from "../../apis/3DApis";
import { Toast } from "primereact/toast";
import { Spin } from "antd";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { useForm, Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateTimeProcess3D } from "../../apis/SettingApis";
import { use } from "react";

const Config3D = () => {
  const [apiLoading, setApiLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [initialLoad, setInitialLoad] = useState(false);
  const [fileName, setFileName] = useState("");
  const [algorithm, setAlgorithm] = useState("min-crop");
  const [verticalSliceThickness, setVerticalSliceThickness] = useState(1.0);
  const [verticalSliceSpacing, setVerticalSliceSpacing] = useState(1.0);
  const [horizontalSliceThickness, setHorizontalSliceThickness] = useState(1.7);
  const [expandingMissingPart, setExpandingMissingPart] = useState(true);
  const [firstVerticalLineShift, setFirstVerticalLineShift] = useState(0);
  const [cropPoints, setCropPoints] = useState("");
  const [fileView, setFileView] = useState("top-view-item");
  const [currentRotation, setCurrentRotation] = useState(0);
  const [stage, setStage] = useState(2);
  const [showBars, setShowBars] = useState(false);
  const [imageInfo, setImageInfo] = useState({});
  const { currentUser = {} } = useSelector(({ app }) => app);
  const [numRemainProcess3D, setNumRemainProcess3D] = useState(0);

  const viewItemBars = {
    "top-view-item-hbar-topleft": useRef(null),
    "top-view-item-vbar-topleft": useRef(null),
    "top-view-item-hbar-bottomright": useRef(null),
    "top-view-item-vbar-bottomright": useRef(null),

    "side-view-1-item-hbar-topleft": useRef(null),
    "side-view-1-item-vbar-topleft": useRef(null),
    "side-view-1-item-hbar-bottomright": useRef(null),
    "side-view-1-item-vbar-bottomright": useRef(null),

    "side-view-2-item-hbar-topleft": useRef(null),
    "side-view-2-item-vbar-topleft": useRef(null),
    "side-view-2-item-hbar-bottomright": useRef(null),
    "side-view-2-item-vbar-bottomright": useRef(null),
  };

  const topViewImage = useRef(null);
  const imageContainer = useRef(null);

  const viewImage = useRef(null);
  const viewItems = {"top-view-item": useRef(null), "side-view-1-item": useRef(null), "side-view-2-item": useRef(null)};

  const additionalImage1 = useRef(null);
  const additionalImage2 = useRef(null);
  const additionalImages = useRef(null);

  const hbar = useRef(null);
  const vbar = useRef(null);
  const hbartopLeft = useRef(null);
  const vbartopLeft = useRef(null);
  const hbarbottomRight = useRef(null);
  const vbarbottomRight = useRef(null);

  const toolContent = useRef(null);
  const toolContainer = useRef(null);

  // UI crop tool functions
  function loaded() {
    setStage(0);
    setShowBars(true);
    ResetFrameBars();
  };
  function ResetFrameBars()
  {
    hbar.current.style.top = "0px";
    vbar.current.style.left = "0px";
    vbar.current.style.height = "0px";
    hbar.current.style.width = "0px";

    hbartopLeft.current.style.width = "0px";
    hbartopLeft.current.style.top = "0px";
    vbartopLeft.current.style.height = "0px";
    vbartopLeft.current.style.left = "0px";

    hbarbottomRight.current.style.width = "0px";
    hbarbottomRight.current.style.top = "0px";
    vbarbottomRight.current.style.height = "0px";
    vbarbottomRight.current.style.left = "0px";

    let clr = "#000";
    hbartopLeft.current.style.backgroundColor = clr;
    vbartopLeft.current.style.backgroundColor = clr;
    hbarbottomRight.current.style.backgroundColor = clr;
    vbarbottomRight.current.style.backgroundColor = clr;
  }
  const init = () => {
    imageInfo["top-view-item"] = {};
    imageInfo["top-view-item"]["width"] = 0;
    imageInfo["top-view-item"]["height"] = 0;
    imageInfo["top-view-item"]["topleft"] = {};
    imageInfo["top-view-item"]["topleft"]["X"] = -1;
    imageInfo["top-view-item"]["topleft"]["Y"] = -1;
    imageInfo["top-view-item"]["bottomright"] = {};
    imageInfo["top-view-item"]["bottomright"]["X"] = -1;
    imageInfo["top-view-item"]["bottomright"]["Y"] = -1;

    imageInfo["side-view-1-item"] = {};
    imageInfo["side-view-1-item"]["width"] = 0;
    imageInfo["side-view-1-item"]["height"] = 0;
    imageInfo["side-view-1-item"]["topleft"] = {};
    imageInfo["side-view-1-item"]["topleft"]["X"] = -1;
    imageInfo["side-view-1-item"]["topleft"]["Y"] = -1;
    imageInfo["side-view-1-item"]["bottomright"] = {};
    imageInfo["side-view-1-item"]["bottomright"]["X"] = -1;
    imageInfo["side-view-1-item"]["bottomright"]["Y"] = -1;

    imageInfo["side-view-2-item"] = {};
    imageInfo["side-view-2-item"]["width"] = 0;
    imageInfo["side-view-2-item"]["height"] = 0;
    imageInfo["side-view-2-item"]["topleft"] = {};
    imageInfo["side-view-2-item"]["topleft"]["X"] = -1;
    imageInfo["side-view-2-item"]["topleft"]["Y"] = -1;
    imageInfo["side-view-2-item"]["bottomright"] = {};
    imageInfo["side-view-2-item"]["bottomright"]["X"] = -1;
    imageInfo["side-view-2-item"]["bottomright"]["Y"] = -1;

    viewItemBars["top-view-item-hbar-topleft"].current.style.width = "0px";
    viewItemBars["top-view-item-hbar-topleft"].current.style.top = "0px";
    viewItemBars["top-view-item-vbar-topleft"].current.style.height = "0px";
    viewItemBars["top-view-item-vbar-topleft"].current.style.left = "0px";

    viewItemBars["top-view-item-hbar-bottomright"].current.style.width = "0px";
    viewItemBars["top-view-item-hbar-bottomright"].current.style.top = "0px";
    viewItemBars["top-view-item-vbar-bottomright"].current.style.height = "0px";
    viewItemBars["top-view-item-vbar-bottomright"].current.style.left = "0px";

    viewItemBars["side-view-1-item-hbar-topleft"].current.style.width = "0px";
    viewItemBars["side-view-1-item-hbar-topleft"].current.style.top = "0px";
    viewItemBars["side-view-1-item-vbar-topleft"].current.style.height = "0px";
    viewItemBars["side-view-1-item-vbar-topleft"].current.style.left = "0px";

    viewItemBars["side-view-1-item-hbar-bottomright"].current.style.width = "0px";
    viewItemBars["side-view-1-item-hbar-bottomright"].current.style.top = "0px";
    viewItemBars["side-view-1-item-vbar-bottomright"].current.style.height = "0px";
    viewItemBars["side-view-1-item-vbar-bottomright"].current.style.left = "0px";

    viewItemBars["side-view-2-item-hbar-topleft"].current.style.width = "0px";
    viewItemBars["side-view-2-item-hbar-topleft"].current.style.top = "0px";
    viewItemBars["side-view-2-item-vbar-topleft"].current.style.height = "0px";
    viewItemBars["side-view-2-item-vbar-topleft"].current.style.left = "0px";

    viewItemBars["side-view-2-item-hbar-bottomright"].current.style.width = "0px";
    viewItemBars["side-view-2-item-hbar-bottomright"].current.style.top = "0px";
    viewItemBars["side-view-2-item-vbar-bottomright"].current.style.height = "0px";
    viewItemBars["side-view-2-item-vbar-bottomright"].current.style.left = "0px";

    hbartopLeft.current.style.top = "0px";
    hbartopLeft.current.style.left = "0px";
    hbartopLeft.current.style.width = "0px";
    vbartopLeft.current.style.top = "0px";
    vbartopLeft.current.style.left = "0px";
    vbartopLeft.current.style.height = "0px";

    hbarbottomRight.current.style.top = "0px";
    hbarbottomRight.current.style.left = "0px";
    hbarbottomRight.current.style.width = "0px";
    vbarbottomRight.current.style.top = "0px";
    vbarbottomRight.current.style.left = "0px";
    vbarbottomRight.current.style.height = "0px"

    hbar.current.style.top = "0px";
    // hbar.current.style.left = "0px";
    hbar.current.style.width = "0px";
    // vbar.current.style.top = "0px";
    vbar.current.style.left = "0px";
    vbar.current.style.height = "0px";

    let clr = "#00cc00";
    hbartopLeft.current.style.backgroundColor = clr;
    vbartopLeft.current.style.backgroundColor = clr;
    hbarbottomRight.current.style.backgroundColor = clr;
    vbarbottomRight.current.style.backgroundColor = clr;

    Object.entries(viewItems).map(([key, val]) => {
      val.current.parentElement.classList.remove("selected");
      val.current.parentElement.classList.remove("error");
      val.current.parentElement.classList.remove("completed")
    });
    viewImage.current.src = viewItems[fileView].current.src;
    viewItems[fileView].current.parentElement.classList.add("selected");
    updateToolView();
  };
  function SwitchItem(view)
  {
    Object.entries(viewItems).map(([key, val]) => {
      val.current.parentElement.classList.remove("selected");
      val.current.parentElement.classList.remove("error");
      val.current.parentElement.classList.remove("completed");
    });
    viewImage.current.src = viewItems[view].current.src;

    viewItems[view].current.parentElement.classList.add("selected");

    setFileView(view);

    if (
        (imageInfo[view]["topleft"]["X"] >= 0) &&
        (imageInfo[view]["topleft"]["Y"] >= 0) &&
        (imageInfo[view]["bottomright"]["X"] >= 0) &&
        (imageInfo[view]["bottomright"]["Y"] >= 0)
      )
    {
      var offX = viewImage.current.offsetLeft;
      var offY = viewImage.current.offsetTop;

      var topLeftX = Math.round((imageInfo[view]["topleft"]["X"] * viewImage.current.width) / imageInfo[view]["width"]) + offX;
      var topLeftY = Math.round((imageInfo[view]["topleft"]["Y"] * viewImage.current.height) / imageInfo[view]["height"]) + offY;
      var bottomRightX = Math.round((imageInfo[view]["bottomright"]["X"] * viewImage.current.width) / imageInfo[view]["width"]) + offX;
      var bottomRightY = Math.round((imageInfo[view]["bottomright"]["Y"] * viewImage.current.height) / imageInfo[view]["height"]) + offY;
      DrawFrame(topLeftX, topLeftY, bottomRightX, bottomRightY);
      setStage(2);
      setShowBars(false);
    }
    else
    {
      loaded();
    }
  }
  function loadImage(src, image)
  {
    let view = image.current.id;
    image.current.src = "";
    let img = new Image();
    img.onload = function()
    {
      imageInfo[view]["width"] = this.width;
      imageInfo[view]["height"] = this.height;
      image.current.src = img.src;
    }
    img.src = src;
  }

  function updateImageSource()
  {
    if (fileName !== "") {
      topViewImage.current.src = APP_3D_API_URL + `/get_image?file=${encodeURIComponent(fileName)}&view=top_view`;
      imageContainer.current.style.display = 'block';
      additionalImages.current.style.display = 'none';

      viewImage.current.src = "";
      viewImage.current.src = APP_3D_API_URL + `/get_image?file=${encodeURIComponent(fileName)}&view=${encodeURIComponent(fileView.replaceAll("-", "_"))}`;
      let topViewItemsrc = APP_3D_API_URL + `/get_image?file=${encodeURIComponent(fileName)}&view=${encodeURIComponent("top_view_item")}`;
      let sideView1Itemsrc = APP_3D_API_URL + `/get_image?file=${encodeURIComponent(fileName)}&view=${encodeURIComponent("side_view_1_item")}`;
      let sideView2Itemsrc = APP_3D_API_URL + `/get_image?file=${encodeURIComponent(fileName)}&view=${encodeURIComponent("side_view_2_item")}`;

      // LoadImage(viewImagesrc, viewImage);
      loadImage(topViewItemsrc, viewItems["top-view-item"]);
      loadImage(sideView1Itemsrc, viewItems["side-view-1-item"]);
      loadImage(sideView2Itemsrc, viewItems["side-view-2-item"]);
      // updateToolView();
    } else {
      imageContainer.current.style.display = 'none';
      toolContainer.current.style.display = 'none';
    }
  }
  function onMouseMove(event)
  {
    if (showBars === false)
    {
      return;
    }
    hbar.current.style.top = Math.max(event.pageY, hbartopLeft.current.offsetTop) + "px";
    vbar.current.style.left = Math.max(event.pageX, vbartopLeft.current.offsetLeft) + "px";
    vbar.current.style.height = (toolContent.current.offsetHeight - 20) + "px";
    hbar.current.style.width = (toolContent.current.offsetWidth - 20) + "px";
    hbartopLeft.current.style.width = hbar.current.offsetWidth + "px";
    hbartopLeft.current.style.left = hbar.current.offsetLeft + "px";
    vbartopLeft.current.style.top = vbar.current.offsetTop + "px";
    hbarbottomRight.current.style.left = hbar.current.offsetLeft + "px";
    vbarbottomRight.current.style.top = vbar.current.offsetTop + "px";
  }
  function onMouseDown(event)
  {
    if (
          (event.pageX < viewImage.current.offsetLeft) ||
          (event.pageX > (
                          viewImage.current.offsetLeft +
                          viewImage.current.offsetWidth)
                          ) ||
          (event.pageY < viewImage.current.offsetTop) ||
          (event.pageY > (
                          viewImage.current.offsetTop +
                          viewImage.current.offsetHeight)
                          )
      )
    {
      return;
    }
    if (stage === 0)
    {
      hbartopLeft.current.style.top = hbar.current.offsetTop + "px";
      hbartopLeft.current.style.left = hbar.current.offsetLeft + "px";
      hbartopLeft.current.style.width = hbar.current.offsetWidth + "px";
      vbartopLeft.current.style.top = vbar.current.offsetTop + "px";
      vbartopLeft.current.style.left = vbar.current.offsetLeft + "px";
      vbartopLeft.current.style.height = vbar.current.offsetHeight + "px";

      // hbarbottomRight.current.style.top = "0px";
      // hbarbottomRight.current.style.left = "0px";
      // hbarbottomRight.current.style.width = "0px";
      // vbarbottomRight.current.style.top = "0px";
      // vbarbottomRight.current.style.left = "0px";
      // vbarbottomRight.current.style.height = "0px";
      setStage(1);
    }
    else if (stage === 1)
    {
      let topLeftX = vbartopLeft.current.offsetLeft;
      let topLeftY = hbartopLeft.current.offsetTop;
      let bottomRightX = vbar.current.offsetLeft;
      let bottomRightY = hbar.current.offsetTop;
      let frameheight = bottomRightY - topLeftY;
      let framewidth = bottomRightX - topLeftX;
      if ((framewidth == 0) || (frameheight == 0))
      {
        return;
      }
      DrawFrame(topLeftX, topLeftY, bottomRightX, bottomRightY);

      // Save frame coordinates
      let topLeftXImg = Math.round(((topLeftX - viewImage.current.offsetLeft) * imageInfo[fileView]["width"] ) / viewImage.current.width);
      let topLeftYImg = Math.round(((topLeftY - viewImage.current.offsetTop) * imageInfo[fileView]["height"] ) / viewImage.current.height);
      let bottomRightXImg = Math.round(((bottomRightX - viewImage.current.offsetLeft) * imageInfo[fileView]["width"] ) / viewImage.current.width);
      let bottomRightYImg = Math.round(((bottomRightY - viewImage.current.offsetTop) * imageInfo[fileView]["height"] ) / viewImage.current.height);
      imageInfo[fileView]["topleft"]["X"] = topLeftXImg;
      imageInfo[fileView]["topleft"]["Y"] = topLeftYImg;
      imageInfo[fileView]["bottomright"]["X"] = bottomRightXImg;
      imageInfo[fileView]["bottomright"]["Y"] = bottomRightYImg;

      ///////////////////////////
      /// Item frame          ///
      ///////////////////////////
      let imgItemID = fileView;
      let imgItemPrefix = imgItemID + '-';
      let imgItemOffX = viewItems[fileView].current.offsetLeft;
      let imgItemOffY = viewItems[fileView].current.offsetTop;
      let topLeftXItem = Math.round((imageInfo[fileView]["topleft"]["X"] * viewItems[fileView].current.width) / imageInfo[fileView]["width"]) + imgItemOffX;
      let topLeftYItem = Math.round((imageInfo[fileView]["topleft"]["Y"] * viewItems[fileView].current.height) / imageInfo[fileView]["height"]) + imgItemOffY;
      let bottomRightXItem = Math.round((imageInfo[fileView]["bottomright"]["X"] * viewItems[fileView].current.width) / imageInfo[fileView]["width"]) + imgItemOffX;
      let bottomRightYItem = Math.round((imageInfo[fileView]["bottomright"]["Y"] * viewItems[fileView].current.height) / imageInfo[fileView]["height"]) + imgItemOffY;
      let itemheight = bottomRightYItem - topLeftYItem;
      let itemwidth = bottomRightXItem - topLeftXItem;

      viewItemBars[imgItemPrefix + 'hbar-topleft'].current.style.top = topLeftYItem + "px";
      viewItemBars[imgItemPrefix + 'hbar-topleft'].current.style.left = topLeftXItem + "px";
      viewItemBars[imgItemPrefix + 'hbar-topleft'].current.style.width = itemwidth + "px";
      viewItemBars[imgItemPrefix + 'vbar-topleft'].current.style.top = topLeftYItem + "px";
      viewItemBars[imgItemPrefix + 'vbar-topleft'].current.style.left = topLeftXItem + "px";
      viewItemBars[imgItemPrefix + 'vbar-topleft'].current.style.height = itemheight + "px"

      viewItemBars[imgItemPrefix + 'hbar-bottomright'].current.style.top = bottomRightYItem + "px";
      viewItemBars[imgItemPrefix + 'hbar-bottomright'].current.style.left = topLeftXItem + "px";
      viewItemBars[imgItemPrefix + 'hbar-bottomright'].current.style.width = itemwidth + "px";
      viewItemBars[imgItemPrefix + 'vbar-bottomright'].current.style.top = topLeftYItem + "px";
      viewItemBars[imgItemPrefix + 'vbar-bottomright'].current.style.left = bottomRightXItem + "px";
      viewItemBars[imgItemPrefix + 'vbar-bottomright'].current.style.height = itemheight + "px"

      let clr = "#cc0000";
      viewItemBars[imgItemPrefix + 'hbar-topleft'].current.style.backgroundColor = clr;
      viewItemBars[imgItemPrefix + 'vbar-topleft'].current.style.backgroundColor = clr;
      viewItemBars[imgItemPrefix + 'hbar-bottomright'].current.style.backgroundColor = clr;
      viewItemBars[imgItemPrefix + 'vbar-bottomright'].current.style.backgroundColor = clr;
      ///////////////////////////

      setStage(2);
      setShowBars(false);
    }
    else if (stage === 2)
    {
      ResetFrameBars();

      hbar.current.style.top = event.pageY + "px";
      // hbar.current.style.left = "0px";
      hbar.current.style.width = (toolContent.offsetWidth - 20) + "px";
      // vbar.current.style.top = "0px";
      vbar.current.style.left = event.pageX + "px";
      vbar.current.style.height = (toolContent.offsetHeight - 20) + "px";
      setStage(0);
      setShowBars(true);
    }
  }
  function DrawFrame(topLeftX, topLeftY, bottomRightX, bottomRightY)
  {
    let frameheight = bottomRightY - topLeftY;
    let framewidth = bottomRightX - topLeftX;
    if ((framewidth == 0) || (frameheight == 0))
    {
      return;
    }
    hbartopLeft.current.style.top = topLeftY + "px";
    hbartopLeft.current.style.left = topLeftX + "px";
    hbartopLeft.current.style.width = framewidth + "px";
    vbartopLeft.current.style.top = topLeftY + "px";
    vbartopLeft.current.style.left = topLeftX + "px";
    vbartopLeft.current.style.height = frameheight + "px";

    hbarbottomRight.current.style.top = bottomRightY + "px";
    hbarbottomRight.current.style.left = topLeftX + "px";
    hbarbottomRight.current.style.width = framewidth + "px";
    vbarbottomRight.current.style.top = topLeftY + "px";
    vbarbottomRight.current.style.left = bottomRightX + "px";
    vbarbottomRight.current.style.height = frameheight + "px"

    hbar.current.style.top = "0px";
    // hbar.current.style.left = "0px";
    hbar.current.style.width = "0px";
    // vbar.current.style.top = "0px";
    vbar.current.style.left = "0px";
    vbar.current.style.height = "0px";

    let clr = "#00cc00";
    hbartopLeft.current.style.backgroundColor = clr;
    vbartopLeft.current.style.backgroundColor = clr;
    hbarbottomRight.current.style.backgroundColor = clr;
    vbarbottomRight.current.style.backgroundColor = clr;
  }

  function updateToolView()
  {
    toolContainer.current.style.display = (algorithm === 'manual') ? 'block' : 'none';
  };

  const toggleOptions = () => {
    let rvst = document.getElementById("row_vertical_slice_thickness");
    let rvss = document.getElementById("row_vertical_slice_spacing");
    let rhst = document.getElementById("row_horizontal_slice_thickness");
    let rfvls = document.getElementById("row_first_vertical_line_shift");
    if (rvst && rvss && rhst && rfvls)
    {
      let displayStyle = (rvst.style.display == "none") ? "flex" : "none";
      document.getElementById("show_more").innerHTML = (displayStyle == "none") ? "Show more" : "Hide";
      rvst.style.display = displayStyle;
      rvss.style.display = displayStyle;
      rhst.style.display = displayStyle;
      rfvls.style.display = displayStyle;
    }
  };

  const rotateImage = (degrees) => {
    let newRotation = currentRotation + degrees;
    setCurrentRotation(newRotation);
    topViewImage.current.style.transform = 'rotate(' + newRotation + 'deg)';
    handleRotation(newRotation);
  };

  function showAdditionalImages() {
    additionalImage1.current.src = APP_3D_API_URL + `/get_image_key_plan_old?file=${encodeURIComponent(fileName)}`;
    additionalImage2.current.src = APP_3D_API_URL + `/get_image_key_plan_new?file=${encodeURIComponent(fileName)}`;
    additionalImages.current.style.display = 'flex';
  }

  function ValidateForm()
  {
    let crop_pts = "";
    if (algorithm === "manual")
    {
      let bValid = true;
      Object.entries(viewItems).map(([key, val]) => {
        val.current.parentElement.classList.remove("selected");
        val.current.parentElement.classList.remove("error");
        val.current.parentElement.classList.remove("completed");
        if (!
            (
              (imageInfo[key]["width"] > 0) &&
              (imageInfo[key]["height"] > 0) &&
              (imageInfo[key]["topleft"]["X"] >= 0) &&
              (imageInfo[key]["topleft"]["Y"] >= 0) &&
              (imageInfo[key]["bottomright"]["X"] >= 0) &&
              (imageInfo[key]["bottomright"]["Y"] >= 0)
            )
          )
        {
          bValid = false;
          val.current.parentElement.classList.add("error");
        }
        else
        {
          val.current.parentElement.classList.add("completed");
        }
        crop_pts += ((crop_pts == "") ? "" : ";") + imageInfo[key]["topleft"]["X"];
        crop_pts += ";" + imageInfo[key]["topleft"]["Y"];
        crop_pts += ";" + imageInfo[key]["bottomright"]["X"];
        crop_pts += ";" + imageInfo[key]["bottomright"]["Y"];
      });
      if (! bValid)
      {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Not all crop points are set.\n\nManual crop requires setting crop points on all three views.",
          life: 5000,
        });
        return {"status": false, "crop_points": ""};
      }
      setCropPoints(crop_pts);
    }
    return {"status": true, "crop_points": crop_pts};
  }
  // End UI crop tool functions

  const toast = useRef(null);

  const dispatch = new useDispatch();
  const defaultValues = {
    file_select: "",
    file_view: "top_view_item",
    vertical_slice_thickness: 1.0,
    vertical_slice_spacing: 1.0,
    horizontal_slice_thickness: 1.7,
    expanding_missing_part: true,
    algorithm: "min-crop",
    first_vertical_line_shift: "0",
    rot_angle: "",
    crop_points: ""
  };
  const { control, handleSubmit, reset } = useForm({ defaultValues });
  const algorithms = [
    { label: "Default.......................(good when only rotation is needed)", value: "default" },
    { label: "Min crop.....................(good if the plan needs to be zoomed out)", value: "min-crop" },
    { label: "New crop algorithm....(good if `Min crop` is still not showing everything)", value: "new-crop" },
    { label: "Manual crop tool.........(for manual selection of the size of the slices. e.g., a very big garden where we want better slices for a small shed)", value: "manual" }
  ];
  function handleUpdateTimeProcess3D() {
    setApiLoading(true);
    updateTimeProcess3D()
    .then((response) => {
        if ((response.status = 200)) {
          setNumRemainProcess3D(numRemainProcess3D - 1);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: "Request failed.",
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e.toString(),
          life: 3000,
        });
        setApiLoading(false);
      });
  }

  function handleProcess(values) {
    setApiLoading(true);
    processProject(values)
    .then((response) => {
        if ((response.status % 200) < 100) {
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: (response.status === 204) ? "File processing skipped." : response.data["message"],
            life: 3000,
          });
          if (response.status == 202)
          {
            reset();
            init();
          }
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: "Request failed.",
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e.toString(),
          life: 3000,
        });
        setApiLoading(false);
      });
  }
  const onSubmit = (data, bAdv) => {
    data["password"] = "default";
    let result = ValidateForm();
    if (result["status"])
    {
      if (bAdv)
      {
        data["password"] = prompt("Enter password for advanced process");
      }
      if (data["password"] != null)
      {
        data["rot_angle"] = currentRotation;
        data["crop_points"] = result["crop_points"];
        data["vertical_slice_thickness"] =  verticalSliceThickness;
        data["vertical_slice_spacing"] =  verticalSliceSpacing;
        data["horizontal_slice_thickness"] =  horizontalSliceThickness;
        data["expanding_missing_part"] = expandingMissingPart;
        data["first_vertical_line_shift"] =  firstVerticalLineShift;
        handleProcess(data);
        handleUpdateTimeProcess3D();
        // reset();
      }
    }
  };
  const loadRecentProjects = () => {
    setApiLoading(true);
    getRecentProjects()
      .then((response) => {
        if (response.status === 200) {
          let projs = [];
          response.data["files"].forEach((val) => {
            projs.push({"label": val, "value": val});
          });
          setProjects(projs);
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: response.data["message"],
            life: 3000,
          });
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.data["message"],
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e.toString(),
          life: 3000,
        });
        setApiLoading(false);
      });
  };
  function handleRotation(rot) {
    setApiLoading(true);
    updateRotation({"rotation": rot})
    .then((response) => {
        if (response.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: response.data["message"],
            life: 3000,
          });
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: "Request failed.",
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e.toString(),
          life: 3000,
        });
        setApiLoading(false);
      });
  }
  useEffect(() => {
    if (initialLoad === false)
    {
      loaded();
      init();
      loadRecentProjects();
      setInitialLoad(true);
    }
    updateImageSource();
    updateToolView();
  });

  useEffect(() => {
    if(currentUser != null) {
      setNumRemainProcess3D(4 - currentUser["numTimeProcess3D"] || 0);
    }
  }, [currentUser]);

  const projectChanged = (value) => {
    init();
    setFileName(value);
  };

  const hiddenStyle = {
    display: "none"
  };
  const transformStyle = {
    transform: "rotate(0 deg)"
  };

  return (
    <React.Fragment>
    <div>
      <Toast ref={toast} />
      { /*<h2>Currently running threads: <thread_count /></h2>*/ }
      <div id="top-menu">
        { <button onClick={loadRecentProjects} className="button">Refresh</button> }
      </div>
      <h1>Select File and Parameters</h1>

      <Spin spinning={apiLoading}>
        <form className="p-fluid">
          <div className="tablelistwrapper">
            <div className="tablelist">
              <div className="row">
                <div className="celllabel">
                  <label htmlFor="file_select">Select a file:</label>
                </div>
                <div className="cellfield">
                  <Controller
                    name="file_select"
                    control={control}
                    rules={{ required: "Select a project" }}
                    render={({ field, fieldState }) => (
                    <Dropdown
                      id={field.name}
                      {...field}
                      options={projects}
                      className="fieldselect"
                      filter
                      onChange={(e) => {projectChanged(e.value); field.onChange(e);}}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="row">
                <div className="celllabel">
                  <label htmlFor="algorithm">Crop algorithm</label>:
                </div>
                <div className="cellfield">
                  <Controller
                    name="algorithm"
                    control={control}
                    rules={{ required: "Select algorithm" }}
                    render={({ field, fieldState }) => (
                    <Dropdown
                      id={field.name}
                      {...field}
                      options={algorithms}
                      defaultValue="manual"
                      className="fieldselect"
                      style={{ FontFace: "monospace" }}
                      onChange={(e) => {setAlgorithm(e.value); updateToolView(); field.onChange(e);}}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="rowblank">
                <a id="show_more" onClick={() => toggleOptions()}>Show more</a>
              </div>
              <div className="row" id="row_vertical_slice_thickness" style={hiddenStyle}>
                <div className="celllabel">
                  <label htmlFor="vertical_slice_thickness">Vertical Slice Thickness (meters, 0.5-3)</label>:
                </div>
                <div className="cellfield">
                  <Controller
                    name="vertical_slice_thickness"
                    control={control}
                    rules={{ required: "Vertical slice thickness is required.", valueAsNumber: true }}
                    render={({ field, fieldState }) => (
                    <InputNumber
                      id={field.name}
                      {...field}
                      className="fieldinput"
                      value={verticalSliceThickness}
                      onValueChange={(e) => setVerticalSliceThickness(e.value)}
                      maxFractionDigits={1}
                      min={0.5}
                      max={3}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="row" id="row_vertical_slice_spacing" style={hiddenStyle}>
                <div className="celllabel">
                  <label htmlFor="vertical_slice_spacing">Vertical Slice Spacing (meters, 0.1-5)</label>:
                </div>
                <div className="cellfield">
                  <Controller
                    name="vertical_slice_spacing"
                    control={control}
                    rules={{ required: "Vertical slice spacing is required.", valueAsNumber: true }}
                    render={({ field, fieldState }) => (
                    <InputNumber
                      id={field.name}
                      {...field}
                      className="fieldinput"
                      value={verticalSliceSpacing}
                      onValueChange={(e) => setVerticalSliceSpacing(e.value)}
                      maxFractionDigits={1}
                      min={0.1}
                      max={5}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="row" id="row_horizontal_slice_thickness" style={hiddenStyle}>
                <div className="celllabel">
                  <label htmlFor="horizontal_slice_thickness">Horizontal Slice Thickness (meters, 0.5-3)</label>:
                </div>
                <div className="cellfield">
                  <Controller
                    name="horizontal_slice_thickness"
                    control={control}
                    rules={{ required: "Horizontal slice thickness is required.", valueAsNumber: true }}
                    render={({ field, fieldState }) => (
                    <InputNumber
                      id={field.name}
                      {...field}
                      className="fieldinput"
                      value={horizontalSliceThickness}
                      onValueChange={(e) => setHorizontalSliceThickness(e.value)}
                      maxFractionDigits={1}
                      min={0.5}
                      max={3}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="row" style={hiddenStyle}>
                <div className="celllabel">
                  <label htmlFor="expanding_missing_part">Expanding vertical space</label>:
                </div>
                <div className="cellfield">
                  <Controller
                    name="expanding_missing_part"
                    control={control}
                    render={({ field, fieldState }) => (
                    <Checkbox
                      id={field.name}
                      {...field}
                      className="fieldinput"
                      checked={expandingMissingPart}
                      onChange={(e) => setExpandingMissingPart(e.checked)}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="row" id="row_first_vertical_line_shift" style={hiddenStyle}>
                <div className="celllabel">
                  <label htmlFor="first_vertical_line_shift">First vertical line shift (meters, 0-5)</label>:
                </div>
                <div className="cellfield">
                  <Controller
                    name="first_vertical_line_shift"
                    control={control}
                    rules={{ required: "First vertical line shift is required.", valueAsNumber: true }}
                    render={({ field, fieldState }) => (
                    <InputNumber
                      id={field.name}
                      {...field}
                      className="fieldinput"
                      value={firstVerticalLineShift}
                      onValueChange={(e) => setFirstVerticalLineShift(e.value)}
                      maxFractionDigits={1}
                      min={0}
                      max={5}
                    />
                    )}
                  />
                </div>
              </div>
              <div className="rowblank">
                <div className="celllabel">
                </div>
                  <div className="cellfieldflex">
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: '400px' }}>

                      <Button
                        type="button"
                        label="Process"
                        icon="pi"
                        disabled={numRemainProcess3D <= 0 && !isManagerOrAdmin(currentUser)}
                        className="custom-button"
                        onClick={handleSubmit((data) => { onSubmit(data, false) })}
                      />
                      <Button
                        type="button"
                        label="Process advanced"
                        icon="pi"
                        disabled={numRemainProcess3D <= 0 && !isManagerOrAdmin(currentUser)}
                        style={{backgroundColor: '#fa8209', borderColor: '#fa8209'}}
                        className="custom-button custom-button-color"
                        onClick={handleSubmit((data) => { onSubmit(data, true) })}
                      />
                      {currentUser != null && !isManagerOrAdmin(currentUser)
                        && numRemainProcess3D > 0 && (<p>{numRemainProcess3D} times remaining.</p>)}
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </form>
      </Spin>

      <div id="tool-container" ref={toolContainer}>
        <div id="tool-gallery">
          <div className="item">
            <div id="top-view-item-hbar-topleft" className="hbar" ref={viewItemBars["top-view-item-hbar-topleft"]}></div>
            <div id="top-view-item-vbar-topleft" className="vbar" ref={viewItemBars["top-view-item-vbar-topleft"]}></div>
            <div id="top-view-item-hbar-bottomright" className="hbar" ref={viewItemBars["top-view-item-hbar-bottomright"]}></div>
            <div id="top-view-item-vbar-bottomright" className="vbar" ref={viewItemBars["top-view-item-vbar-bottomright"]}></div>
            <img id="top-view-item" src="" className="img" alt="Loading..." onClick={() => SwitchItem('top-view-item')} ref={viewItems["top-view-item"]} />
          </div>
          <div className="item">
            <div id="side-view-1-item-hbar-topleft" className="hbar" ref={viewItemBars["side-view-1-item-hbar-topleft"]}></div>
            <div id="side-view-1-item-vbar-topleft" className="vbar" ref={viewItemBars["side-view-1-item-vbar-topleft"]}></div>
            <div id="side-view-1-item-hbar-bottomright" className="hbar" ref={viewItemBars["side-view-1-item-hbar-bottomright"]}></div>
            <div id="side-view-1-item-vbar-bottomright" className="vbar" ref={viewItemBars["side-view-1-item-vbar-bottomright"]}></div>
            <img id="side-view-1-item" src="" className="img" alt="Loading..." onClick={() => SwitchItem('side-view-1-item')} ref={viewItems["side-view-1-item"]} />
          </div>
          <div className="item">
            <div id="side-view-2-item-hbar-topleft" className="hbar" ref={viewItemBars["side-view-2-item-hbar-topleft"]}></div>
            <div id="side-view-2-item-vbar-topleft" className="vbar" ref={viewItemBars["side-view-2-item-vbar-topleft"]}></div>
            <div id="side-view-2-item-hbar-bottomright" className="hbar" ref={viewItemBars["side-view-2-item-hbar-bottomright"]}></div>
            <div id="side-view-2-item-vbar-bottomright" className="vbar" ref={viewItemBars["side-view-2-item-vbar-bottomright"]}></div>
            <img id="side-view-2-item" src="" className="img" alt="Loading..." onClick={() => SwitchItem('side-view-2-item')} ref={viewItems["side-view-2-item"]} />
          </div>
        </div>
        <div id="tool-image-container">
          <div id="tool-top-row" className="row">
            <div id="tool-top-left" className="square"></div>
            <div id="tool-top-bar" className="horizontal-scale"></div>
            <div id="tool-top-right" className="square"></div>
          </div>
          <div id="tool-mid-row" className="row">
            <div id="tool-mid-left" className="vertical-scale"></div>
            <div id="tool-content" className="content" onMouseMove={(e) => onMouseMove(e)} onMouseDown={(e) => onMouseDown(e)} ref={toolContent}>
              <div id="hbar" className="hbar" ref={hbar}></div>
              <div id="vbar" className="vbar" ref={vbar}></div>
              <div id="hbar-topleft" className="hbar" ref={hbartopLeft}></div>
              <div id="vbar-topleft" className="vbar" ref={vbartopLeft}></div>
              <div id="hbar-bottomright" className="hbar" ref={hbarbottomRight}></div>
              <div id="vbar-bottomright" className="vbar" ref={vbarbottomRight}></div>
              <img id="view-image" src="" ref={viewImage} />
            </div>
            <div id="tool-mid-right" className="vertical-scale"></div>
          </div>
          <div id="tool-bottom-row" className="row">
            <div id="tool-bottom-left" className="square"></div>
            <div id="tool-bottom-bar" className="horizontal-scale"></div>
            <div id="tool-bottom-right" className="square"></div>
          </div>

        </div>
      </div>

      <Spin spinning={apiLoading}>
        <div className="rotation-buttons">
          <button onClick={() => rotateImage(-10)} className="button">-10°</button>
          <button onClick={() => rotateImage(10)} className="button">+10°</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => rotateImage(-2)} className="button">-2°</button>
          <button onClick={() => rotateImage(2)} className="button">+2°</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => rotateImage(-0.1)} className="button">-0.1°</button>
          <button onClick={() => rotateImage(0.1)} className="button">+0.1°</button>
        </div>

        <div id="image-container" ref={imageContainer}>
          <img id="top-view-image" src="" style={transformStyle} ref={topViewImage} />
          <div className="grid-overlay"></div> {/* Overlay for gridlines */}
        </div>

        <div id="additional-images" className="additional-images" ref={additionalImages}>
          <div className="additional-image-container">
            <span className="image-label">Before</span>
            <img id="additional-image-1" className="additional-image" src="" ref={additionalImage1} />
            <span className="image-label">Previous Version</span>
          </div>
          <div className="additional-image-container">
            <span className="image-label">After</span>
            <img id="additional-image-2" className="additional-image" src="" ref={additionalImage2} />
            <span className="image-label">Current version</span>
          </div>
        </div>

        <button onClick={showAdditionalImages} className="button">Show Keyplan Images</button>

        <div className="rotation-buttons">
          <button onClick={() => rotateImage(-10)} className="button">-10°</button>
          <button onClick={() => rotateImage(10)} className="button">+10°</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => rotateImage(-2)} className="button">-2°</button>
          <button onClick={() => rotateImage(2)} className="button">+2°</button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button onClick={() => rotateImage(-0.1)} className="button">-0.1°</button>
          <button onClick={() => rotateImage(0.1)} className="button">+0.1°</button>
        </div>
      </Spin>
    </div>
    </React.Fragment>
  );
};

export default Config3D;